import { Component } from '@angular/core';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'md-pricing-end-product-customers-page',
  standalone: true,
  imports: [PageHeaderComponent, TranslateModule],
  templateUrl: './pricing-end-product-customers-page.component.html',
  styleUrl: './pricing-end-product-customers-page.component.scss'
})
export class PricingEndProductCustomersPageComponent {}
